<template>
  <v-container v-if="items">
    <v-card>
      <v-card-title>
        <v-row align="center" justify="space-between" no-gutters>
          <v-col class="d-none d-md-block">
            <span class="headline no-split-words">
              {{ $t($route.meta.label) }}
            </span>
          </v-col>
          <v-col order="1" order-md="2" class="text-right"> </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          :options="entitiesPage"
          :server-items-length="totalItems"
          :loading="loading"
          :footer-props="tableFooterProps"
          @click:row="entityDetail"
          @update:options="redirectOnTableChange"
        >
          <template v-slot:[`item.action`]="{ item }">
            <v-icon color="primary" @click.stop="entityDetail(item)">
              description
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import defaultPaginationSettings from "@/common/default-pagination-settings";
import tableFooterProps from "@/common/table-footer-props";

import displayManyRelationship from "@/common/DisplayManyRelationships";
import RepositoryFactory from "@/repositories/RepositoryFactory";
const EdificioEntityRepository = RepositoryFactory.get(
  "EdificioEntityRepository"
);

export default {
  name: "edificioListList",
  components: {},
  data() {
    return {
      items: [],
      entitiesPage: {
        page:
          parseInt(this.$route.query.page) || defaultPaginationSettings.page,
        itemsPerPage:
          parseInt(this.$route.query.pageSize) ||
          defaultPaginationSettings.itemsPerPage,
      },
      totalItems: 0,
      loading: false,
      tableFooterProps,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("t_edificio.prop.id"),
          sortable: false,
          value: "id",
        },
        {
          text: this.$t("t_edificio.prop.refCat"),
          sortable: false,
          value: "refCat",
        },
        {
          text: this.$t("t_edificio.prop.heating"),
          sortable: false,
          value: "heating",
        },
        {
          text: this.$t("t_edificio.prop.lighting"),
          sortable: false,
          value: "lighting",
        },
        {
          text: this.$t("t_edificio.prop.cooling"),
          sortable: false,
          value: "cooling",
        },
        {
          text: this.$t("t_edificio.prop.tc"),
          sortable: false,
          value: "tc",
        },
        {
          text: this.$t("t_edificio.prop.constructionYear"),
          sortable: false,
          value: "constructionYear",
        },
        {
          text: this.$t("t_edificio.prop.ct"),
          sortable: false,
          value: "ct",
        },
        { text: "", sortable: false, value: "action" },
      ];
    },
  },
  watch: {},
  created() {
    if (JSON.stringify(this.$route.query) != "{}") this.getItems();
  },
  methods: {
    getItems() {
      this.loading = true;
      const options = {
        params: {
          page: this.entitiesPage.page - 1,
          size: this.entitiesPage.itemsPerPage,
        },
      };
      EdificioEntityRepository.getAll(options)
        .then((response) => {
          this.items = response.content;
          this.totalItems = response.totalElements;
        })
        .finally(() => (this.loading = false));
    },
    redirect(query) {
      if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
        this.$router
          .replace({
            name: "Edificio List",
            query: query,
          })
          .then(() => this.getItems());
      }
    },
    entityDetail(entity) {
      const selection = window.getSelection().toString();
      if (selection.length === 0) {
        this.$router.push({
          name: "Edificio FormDetail",
          params: { id: entity.id, backPrevious: true },
        });
      }
    },
    redirectOnTableChange(pagination = this.entitiesPage) {
      this.entitiesPage = pagination;
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.page = this.entitiesPage.page.toString();
      query.pageSize = this.entitiesPage.itemsPerPage.toString();
      this.redirect(query);
    },
    displayManyRelationship,
  },
};
</script>
